import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';
import { bindServices } from '@/services/api';

const api = bindServices('approversGlobalEntityArea');

const pagination = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const initialState = {
  newGlobalEntityArea: false,
  selectedItem: null,
  formConfig: null,
  list: [],
  pagination,
  select: 'id,approvalLevel,entityValue',
  notSelectSearch: 'approvalLevel',
  expand: {
    area: { select: 'name' },
    dynamicEntity: { select: 'displayName' },
    dynamicEntityField: { select: 'displayName' },
  },
  paramsView: {
    select: 'id,approvalLevel,entityValue,created',
    expand: {
      area: { select: 'name' },
      dynamicEntity: { select: 'displayName' },
      dynamicEntityField: { select: 'displayName' },
      userCreator: { select: 'fullName' },
    },
  },
  paramsEdit: {
    select: 'id,approvalLevel,dynamicEntityId,dynamicEntityFieldId,areaId,entityValue',
  },
  view: false,
  orderBy: '',
  id: null,
};

const Model = {
  namespace: 'globalEntityArea',

  state: initialState,

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(api.getAll, {
          route: 'globalEntityApproverByArea/paged',
          params: payload,
        });

        yield put({
          type: 'setListGlobalEntityArea',
          payload: {
            ...response,
            page: payload.page,
            limit: payload.limit,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *openModalGlobalEntityArea({ payload }, { put }) {
      yield put({
        type: 'addGlobalEntityArea',
        payload,
      });

      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewGlobalEntityArea',
          payload,
        });
      }
    },
    *saveNewGlobalEntityArea({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.create, {
          route: 'globalEntityApproverByArea',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveGlobalEntityArea',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *editItemGlobalEntityArea({ payload }, { call, put }) {
      try {
        const table = yield call(api.getById, {
          route: 'globalEntityApproverByArea',
          id: payload.id,
          params: payload.params,
        });
        yield put({
          type: 'editGlobalEntityArea',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /*  */
      }
    },
    *saveEditGlobalEntityArea({ payload, params }, { call, put }) {
      try {
        const response = yield call(api.update, {
          route: 'globalEntityApproverByArea',
          data: payload,
        });
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'saveGlobalEntityArea',
          payload: response,
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error.message) {
          if (_.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }

          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },
    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        const response = yield call(api.apiRoute, {
          route: `globalEntityApproverByArea/${id}`,
          method: 'delete',
        });

        yield put({
          type: 'saveGlobalEntityArea',
          payload: response,
        });

        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });

        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });

        if (error && error.message) {
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },
    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },
  },

  reducers: {
    setListGlobalEntityArea(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },
    addGlobalEntityArea(state, { payload }) {
      return {
        ...state,
        newGlobalEntityArea: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    editOrViewGlobalEntityArea(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },
    saveGlobalEntityArea(state, { payload }) {
      return {
        ...state,
        saveGlobalEntityArea: payload,
        newGlobalEntityArea: false,
        selectedItem: null,
        view: false,
      };
    },
    editGlobalEntityArea(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },
    showEditItemGlobalEntityArea(state, { view }) {
      return {
        ...state,
        view,
      };
    },
    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },
    hideForms(state) {
      return {
        ...state,
        newGlobalEntityArea: false,
        selectedItem: null,
        formConfig: null,
        list: [],
        view: false,
        orderBy: '',
      };
    },
  },
};

export default Model;
